export default function PartnersSection() {
  const partners = [
    { name: '西甲联赛', icon: 'ri-football-line' },
    { name: '英超联赛', icon: 'ri-football-line' },
    { name: 'NBA联盟', icon: 'ri-basketball-line' },
    { name: 'ATP巡回赛', icon: 'ri-base-station-line' },
    { name: 'LCK联赛', icon: 'ri-computer-line' },
    { name: '意甲联赛', icon: 'ri-football-line' },
    { name: '德甲联赛', icon: 'ri-football-line' },
    { name: '法甲联赛', icon: 'ri-football-line' },
  ];

  return (
    <section className="py-14 bg-background-50 border-t border-background-200/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <p className="text-xs font-bold text-foreground-400 uppercase tracking-widest text-center mb-8">
          合作伙伴
        </p>
        <div className="grid grid-cols-4 md:grid-cols-8 gap-4">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex flex-col items-center gap-2 py-3 px-2 rounded-lg hover:bg-background-100 transition-colors cursor-default"
            >
              <div className="w-10 h-10 rounded-xl bg-background-100 flex items-center justify-center">
                <i className={`${partner.icon} text-foreground-400 text-lg`}></i>
              </div>
              <span className="text-[10px] text-foreground-400 text-center whitespace-nowrap">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}